export const s3Config = {
  buckets: {
    'local-us-west-2': 'dev.social.network.images.and.videos.pleaseshare.co',
    'dev-us-west-2': 'dev.social.network.images.and.videos.pleaseshare.co',
    'stage-us-west-2': 'stage.social.network.images.and.videos.pleaseshare.co',
    'prod-us-east-1': 'prod.social.network.images.and.videos.pleaseshare.co'
  },
  defaultRegion: 'us-west-2'
};
